(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avora-catalog"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('avora-catalog'))customElements.define('avora-catalog',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();const options={signal:this.abort.signal};this.addEventListener('click',event=>{const button=event.target.closest('[data-filter]');if(!button)return;this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('.ac-product').forEach(card=>card.hidden=button.dataset.filter!=='all'&&card.dataset.kind!==button.dataset.filter);},options);this.addEventListener('change',event=>{const input=event.target;if(!input.matches('.ac-form input[type=radio]'))return;const card=input.closest('.ac-product');card.querySelector('[data-color]').textContent=input.dataset.title;card.querySelector('[data-price]').textContent=input.dataset.price;const compare=card.querySelector('[data-compare]');compare.textContent=input.dataset.compare;compare.hidden=!input.dataset.compare;card.querySelectorAll('[data-product-link]').forEach(link=>link.href=input.dataset.url);if(input.dataset.image){const image=card.querySelector('.ac-main-image');image.removeAttribute('srcset');image.src=input.dataset.image;}const b=card.querySelector('.ac-add');b.disabled=input.dataset.available!=='true';b.firstElementChild.textContent=b.disabled?b.dataset.sold:b.dataset.label;},options);this.addEventListener('submit',async event=>{const form=event.target;if(!form.matches('.ac-form'))return;event.preventDefault();const button=form.querySelector('button[type=submit]'),status=form.querySelector('[role=status]');if(button.disabled)return;button.disabled=true;button.setAttribute('aria-busy','true');button.firstElementChild.textContent=button.dataset.loading;status.textContent='';const data=new FormData(form),cart=document.querySelector('cart-drawer');if(cart?.getSectionsToRender){data.append('sections',cart.getSectionsToRender().map(s=>s.id).join(','));data.append('sections_url',location.pathname);}try{const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:data});const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||status.dataset.error);button.firstElementChild.textContent=button.dataset.success;if(cart?.renderContents&&result.sections){cart.classList.remove('is-empty');cart.setActiveElement?.(button);cart.renderContents(result);}else location.assign('/cart');}catch(error){status.textContent=error.message||status.dataset.error;button.firstElementChild.textContent=button.dataset.label;}finally{button.disabled=false;button.removeAttribute('aria-busy');}},options);}
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avora-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.av-mobile-menu[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.removeAttribute('open');});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.av-mobile-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus();});});
document.addEventListener('toggle',event=>{if(!event.target.matches?.('.av-mobile-menu'))return;document.querySelectorAll('#MainContent,.av-footer').forEach(el=>el.inert=event.target.open);},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
